module.exports = __webpack_public_path__ + "img/file_icon.5bb11a8b.svg";